export function foundInArray(variations, dictionary) {
  for (let i3 = 0; i3 < variations.length; i3++) {
    const variation = variations[i3];
    if (variation.trim().length === 0) continue;
    for (let i4 = 0; i4 < dictionary.length; i4++) {
      const word = dictionary[i4];
      if (word.toLocaleLowerCase() === variation.toLocaleLowerCase()) {
        return variation;
      }
    }
  }
  return false;
}

export function isString(element) {
  return typeof element === "string";
}

export function regexMatches(str, reg) {
  return str.match(reg);
}

export function getComputedStyle(element) {
  window.getComputedStyle(element);
}

export function toRgb(element) {
  let computedStyle = getComputedStyle(element);
  let color = computedStyle.getPropertyValue("color");
  let match = color.match(/\d+/g);
  if (match) {
    let r = match[0];
    let g = match[1];
    let b = match[2];
    let rgb = `rgb(${r}, ${g}, ${b})`;
    console.log(rgb);
  }
}

export function colorNameToRgb(name) {
  var canvas = document.createElement("canvas");
  var context = canvas.getContext("2d");
  context.fillStyle = name;
  context.fillRect(0, 0, 1, 1);
  return context.getImageData(0, 0, 1, 1).data;
}

export function getClosestColors(r, g, b, numberOfColors) {
  let colors = [];
  let hue = 0;
  let saturation = 100;
  let lightness = 50;
  let increment = 5;

  for (let i = 0; i < numberOfColors; i++) {
    let color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    let canvas = document.createElement("canvas");
    let context = canvas.getContext("2d");
    context.fillStyle = color;
    let rgb = context.fillStyle;
    let match = rgb.match(/\d+/g);
    if (match) {
      let r = parseInt(match[0]);
      let g = parseInt(match[1]);
      let b = parseInt(match[2]);
      colors.push({ r, g, b });
    }
    lightness += increment;
  }

  return colors;
}

export function addStrength(color, value) {
  let canvas = document.createElement("canvas");
  let context = canvas.getContext("2d");
  context.fillStyle = color;
  let hsl = context.fillStyle;
  let match = hsl.match(/\d+/g);
  if (match) {
    let hue = parseInt(match[0]);
    let saturation = parseInt(match[1]);
    let lightness = parseInt(match[2]);
    lightness += value;
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }
}

export function isInt(str) {
  return !isNaN(Number(str));
}

export function isNotInt(str) {
  return isNaN(Number(str));
}
